<template>
    <v-container>
      <h1>Mes horaires</h1>
      <v-btn
        class="mb-3 mr-3"
        color="secondary"
        @click="generatePDF()"
      >
        <v-icon left>  
          mdi-file-pdf-box
        </v-icon>
        Télécharger en PDF
      </v-btn>
      <v-btn
        class="mb-3 "
        color="accent"
        @click="generateIcal()"
      >
        <v-icon left>  
          mdi-calendar
        </v-icon>
        Exporter pour mon agenda
      </v-btn>


    <v-card >
        <v-card-title>
            Filtres
        </v-card-title>
        <v-card-text>
            <v-row>
                <v-col
                cols="12"
                md="2"
                >
                    <v-menu
                        ref="menuBegin"
                        :close-on-content-click="false"
                        :return-value.sync="filters.begindate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            :value="momentFormattedBegin"
                            clearable
                            prepend-icon="mdi-calendar"
                            label="Date de début"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="filters.begindate = null; datealert = null;"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="filters.begindate"
                            no-title
                            scrollable
                            locale="fr"
                            @change="onDateChange"
                        >
                        <v-spacer></v-spacer>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col
                cols="12"
                md="2"
                >
                    <v-menu
                        ref="menuEnd"
                        :close-on-content-click="false"
                        :return-value.sync="filters.enddate"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                            :value="momentFormattedEnd"
                            clearable
                            label="Date de fin"
                            prepend-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                            @click:clear="filters.enddate = null; datealert = null;"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="filters.enddate"
                            no-title
                            scrollable
                            locale="fr"
                            @change="onDateChange"
                        >
                        <v-spacer></v-spacer>
                        </v-date-picker>
                    </v-menu>
                </v-col>
                <v-col
                cols="12"
                md="2"
                >
                    <v-combobox 
                        label="Fonction"
                        :items="fonctions" 
                        clearable
                        item-value="id" 
                        item-text="nom" 
                        v-model="fonctionCmb" 
                        @change="updateFonction"
                        @click:clear="filters.fonction = undefined; fonctionCmb = undefined;">
                    </v-combobox>
                </v-col>
                <v-col
                cols="12"
                md="2"
                >
                    <v-combobox 
                        label="Site"
                        :items="sites" 
                        clearable
                        item-value="id" 
                        item-text="nom" 
                        v-model="siteCmb" 
                        @change="updateSite"
                        @click:clear="filters.site = undefined; siteCmb = undefined;">
                    </v-combobox>
                </v-col>
            </v-row>
            <v-alert v-if="datealert"
                text
                prominent
                type="error"
                >
                La date de début doit être inférieure à la date de fin
            </v-alert>
        </v-card-text>
    </v-card>


      <v-data-table
        :headers="fields"
        :items="filteredHoraires"
        :items-per-page="10"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        class="elevation-1"
        :loading="loading"
        loading-text="Chargement..."
      >
      <template v-slot:item.date="{ item }">
          {{utils.toPrettyDate(item.date)}}
      </template>
      <template v-slot:item.fonction="{item}">{{fonctionsById[item.id_fonction].nom}}</template>      
      <template v-slot:item.site="{item}">{{sitesById[item.id_site].nom}}</template>  
      <template v-slot:item.sceances="{item}">
        <seances :item="item" />
      </template>
      <template v-slot:item.remp="{item}"><v-btn @click="demandeRemplacement(item.id)" dense><v-icon>mdi-swap-horizontal</v-icon></v-btn></template>
      </v-data-table>
    </v-container>
</template>

<script>
import api from "@/api";
import utils from "@/utils";
import Swal from "sweetalert2";
import Seances from "@/components/Seances";
import moment from "moment";
import store from "@/store";

export default {
  data() {
    return {
      horaires: [],
      perPage: 15,
      currentPage: 1,
      sortBy: "date",
      sortDesc: false,
      fields: [
        { value: "id", text: "Référence", sortable: true },
        { value: "date", text: "Date", sortable: true },
        { value: "site", text: "Site", sortable: false },
        { value: "fonction", text: "Fonction", sortable: false },
        { value: "sceances", text: "Séances", sortable: false },
        { value: "remarque", text: "Remarque", sortable: false },
        { value: "remp", text: "Remplacement", sortable: false },
      ],
      utils: utils,
      filters: {
        fonction: undefined,
        site: undefined,
        begindate: "",
        enddate: "",
      },
      fonctionCmb: undefined,
      siteCmb: undefined,
      datealert: false,
      sites: [],
      sitesById: [],
      fonctions: [],
      fonctionsById: [],
      employes: [],
      employesById: [],
      options: [],
    };
  },
  components: { Seances },
  async created() {
    this.loadData();
  },
  computed: {
    loading() {
      return store.state.loading;
    },
    momentFormattedBegin() {
        return this.filters.begindate ? this.utils.toPrettyDate(this.filters.begindate) : '';
    },
    momentFormattedEnd(){
        return this.filters.enddate ? this.utils.toPrettyDate(this.filters.enddate) : '';
    },
    filteredHoraires() {
      return this.horaires.filter((horaire) => {
        let ok = true;
        if (this.filters.fonction !== undefined) {
          if (horaire.id_fonction !== Number(this.filters.fonction)) {
            ok = false;
          }
        }
        if (ok && this.filters.site !== undefined) {
          if (horaire.id_site !== Number(this.filters.site)) {
            ok = false;
          }
        }
        if (ok && this.filters.begindate !== null) {
          if (moment(horaire.date).isBefore(this.filters.begindate, "day")) {
            ok = false;
          }
        }
        if (ok && this.filters.enddate !== null) {
          if (moment(horaire.date).isAfter(this.filters.enddate, "day")) {
            ok = false;
          }
        }
        if (ok && !horaire.visible) {
          ok = false;
        }
        return ok;
      });
    },
  },
  methods: {
    async loadData(){
    this.$store.commit("setLoading", true);
      this.options['null-null'] = "Non";
      this.fonctions = (await api.getFonctions()).data.fonctions;
      for (let fonction of this.fonctions) {
        this.fonctionsById[fonction.id] = fonction;
      }
      this.sites = (await api.getSites()).data.sites;
      for (let site of this.sites) {
        this.sitesById[site.id] = site;
      }
      this.employes = (await api.getEmployes()).data.employes;
      for (let employe of this.employes) {
        this.employesById[employe.id] = employe;
        if (employe.id != this.$store.state.user.id) this.options[`${employe.nom}-${employe.id}`] = (`${employe.nom} ${employe.prenom}`);
      }
      this.horaires = (await api.getHorairesPerso()).data.horaires;
      this.$store.commit("setLoading", false);
    },
    updateFonction(){
        if (this.fonctionCmb) this.filters.fonction = this.fonctionCmb.id;
    },
    updateSite(){
        if (this.siteCmb) this.filters.site = this.siteCmb.id;
    },
    onDateChange() {
        this.$refs.menuEnd.save(this.filters.enddate);
        this.$refs.menuBegin.save(this.filters.begindate);
        this.datealert =
        this.filters.begindate !== null &&
        this.filters.enddate !== null &&
        moment(this.filters.begindate).isAfter(this.filters.enddate, "day");
    },
    rowClass(item, type) {
      if (!item || type !== "row") return;
      if (item.sib) return "table-secondary";
    },
    generatePDF() {
      api.pdf(`horairesperso`, { filters: this.filters, limit: true }, `horaire`);
    },
    generateIcal() {
      api.ical(`horairesperso`, { filters: this.filters, limit: true }, `horaire`);
    },
    demandeRemplacement(id) {
      Swal.fire({
        title: "Demande de remplacement",
        showCancelButton: true,
        text:"Je me suis déjà mis d'accord avec quelqu'un:",
        input: "select",
        inputOptions: this.options,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Valider",
        cancelButtonText: "Annuler",
      }).then(async (result) => {
        if (result.value) {
          let parts = result.value.split("-");
          let employe_id = parts[parts.length - 1];
          if (employe_id === "null") employe_id = undefined;
          let response = await api.createDemandeRemplacement(id, employe_id);
          Swal.fire({
            type: response.code === 200 ? "success" : "error",
            text: response.message,
          });
        }
      });
    },
  },
};
</script>